export default "__VITE_ASSET__CeX11gJT__"